import { render, staticRenderFns } from "./Social.vue?vue&type=template&id=67e488a4&"
import script from "./Social.vue?vue&type=script&lang=js&"
export * from "./Social.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports